import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import format from "date-fns/format";
import cn from "classnames";

import { getFormattedUserName } from "helpers/chats";

import { FORMAT_DATE_WITH_TIME } from "constants/time";

import styles from "./styles.module.scss";

export default function ChatItem({ onChatClick, conversation, openedEmploeeId }) {
    const { t } = useTranslation();
    const profileId = useSelector((state) => state.profile.profileData.id);
    const { employee, last_message } = conversation;
    const handleClick = () => onChatClick(conversation);
    const userName = useMemo(() => getFormattedUserName(employee), [employee]);
    const messageInformation = `${format(
        new Date(last_message.created_at),
        FORMAT_DATE_WITH_TIME,
    )} ${profileId === last_message.from_user_id ? t("dialog.you") : employee.firstname}: `;

    return (
        <li
            className={cn(styles.chat, openedEmploeeId === employee.id && styles["chat--opened"])}
            onClick={handleClick}
        >
            <div className={styles.chat__wrapper}>
                {employee.picture ? (
                    <img
                        className={styles.chat__image}
                        src={employee.picture || ""}
                        alt=""
                    />
                ) : (
                    <span className={styles.chat__image} />
                )}
                <div className={styles.chat__info}>
                    <p className={styles.chat__title}>{employee.company.name}</p>
                    <p className={styles.chat__name}>{userName}</p>
                </div>
            </div>
            <p className={styles.chat__message}>
                {conversation.is_seen === false && <span className={styles.chat__newMessage} />}
                <span className={styles.chat__from}>{messageInformation}</span>
                {last_message.message || ""}
            </p>
            {/* TODO menu */}
            {/* <div className="chats-list__item-sub-content">
                <div className="chats-list__item-menu">
                    <span className="chats-list__menu-circle" />
                    <span className="chats-list__menu-circle" />
                    <span className="chats-list__menu-circle" />
                </div>
            </div> */}
        </li>
    );
}
